import { ComponentType, ReactNode } from 'react';
import styled from 'styled-components';

import * as _Reach from '@reach/tabs';
import * as Tabs from '@radix-ui/react-tabs';

/**
 * WIP
 * @deprecated All tabs components are being migrated to use @radix-ui/react-tabs.
 * This component will be removed once all components have been migrated.
 * Refer to TradeOverview component for an example.
 */
const Reach = _Reach;
export { Reach };

export * from '@radix-ui/react-tabs';

export const Root = styled(Tabs.Root)`
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
`;

export interface TabData<T = string> {
  readonly id: T;
  readonly label: ReactNode;
  readonly content: ReactNode;
  readonly disabled?: boolean;
}

type BaseDataTabsProps = Omit<_Reach.TabsProps, 'children'>;

/**
 * WIP
 * @deprecated All tabs components are being migrated to use @radix-ui/react-tabs.
 * This component will be removed once all components have been migrated.
 * Refer to TradeOverview component for an example.
 */
export interface DataTabsProps extends BaseDataTabsProps {
  readonly data: readonly TabData[];
  readonly containerComponent?: ComponentType<_Reach.TabsProps>;
  readonly tabComponent?: ComponentType<_Reach.TabProps>;
  readonly tabListComponent?: ComponentType<_Reach.TabListProps>;
  readonly tabPanelsComponent?: ComponentType<_Reach.TabPanelsProps>;
  readonly tabPanelComponent?: ComponentType<_Reach.TabPanelProps>;
}

/**
 * WIP
 * @deprecated All tabs components are being migrated to use @radix-ui/react-tabs.
 * This component will be removed once all components have been migrated.
 * Refer to TradeOverview component for an example.
 */
export function DataTabs(props: DataTabsProps) {
  const {
    data,
    containerComponent: TabsContainer = _Reach.Tabs,
    tabComponent: Tab = _Reach.Tab,
    tabListComponent: TabList = _Reach.TabList,
    tabPanelsComponent: TabPanels = _Reach.TabPanels,
    tabPanelComponent: TabPanel = _Reach.TabPanel,
    ...rest
  } = props;

  return (
    <TabsContainer {...rest}>
      <TabList>
        {data.map((tab, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Tab key={index} disabled={tab.disabled}>
            {tab.label}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {data.map((tab, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <TabPanel key={index}>{tab.content}</TabPanel>
        ))}
      </TabPanels>
    </TabsContainer>
  );
}
